import { getActiveStatus, getProEadActiveStatus } from './status'

const LoyaltyStatus = programCode => {
  const code = parseInt(programCode)
  const getCode = () => code
  const isActive = () => getActiveStatus().includes(code)
  const isProEAD = () => getProEadActiveStatus().includes(code)
  const is = isCode => isCode === code

  return { getCode, isActive, isProEAD, is }
}

export default LoyaltyStatus
